import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import { collection, query, where, getDocs } from 'firebase/firestore';
import { db } from '../../../firebase/config';
import { HiOutlineCog6Tooth } from 'react-icons/hi2';

const AdminLoginPage = () => {
  const navigate = useNavigate();
  const [loginId, setLoginId] = useState('admin');
  const [password, setPassword] = useState('grade2026!');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleLogin = async (e) => {
    e.preventDefault();
    if (!loginId || !password) {
      setError('아이디와 비밀번호를 입력해주세요.');
      return;
    }

    setLoading(true);
    setError('');

    // ── 하드코딩 슈퍼관리자 (Firestore 불필요) ──
    if (loginId === 'admin' && password === 'grade2026!') {
      localStorage.setItem('adminSession', JSON.stringify({
        id: 'superadmin',
        uid: 'superadmin',
        loginId: 'admin',
        name: '1등급 운영자',
        role: 'admin',
        adminRole: 'superadmin',
        loggedInAt: new Date().toISOString(),
      }));
      setLoading(false);
      navigate('/operator');
      return;
    }

    try {
      // loginId로 사용자 검색
      const q = query(
        collection(db, 'users'),
        where('loginId', '==', loginId)
      );
      const snapshot = await getDocs(q);

      if (snapshot.empty) {
        setError('계정을 찾을 수 없습니다.');
        return;
      }

      const adminDoc = snapshot.docs[0];
      const adminData = adminDoc.data();

      // adminRole 체크 (superadmin, teacher, assistant)
      const adminRole = adminData.adminRole;
      if (!adminRole) {
        setError('관리자 권한이 없는 계정입니다.');
        return;
      }

      if (adminData.password !== password) {
        setError('비밀번호가 올바르지 않습니다.');
        return;
      }

      // 관리자 세션 저장 (localStorage — 탭 간 유지)
      localStorage.setItem('adminSession', JSON.stringify({
        id: adminDoc.id,
        uid: adminDoc.id,
        loginId: adminData.loginId,
        name: adminData.name,
        role: adminData.role,
        adminRole: adminRole,
        loggedInAt: new Date().toISOString(),
      }));

      navigate('/admin');
    } catch (err) {
      console.error('관리자 로그인 실패:', err);
      setError('로그인에 실패했습니다. 다시 시도해주세요.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Container data-admin>
      <FloatingIcons>
        <FloatItem style={{ top: '8%', left: '5%', fontSize: '48px', animationDelay: '0s' }}>📚</FloatItem>
        <FloatItem style={{ top: '20%', right: '8%', fontSize: '40px', animationDelay: '1s' }}>✏️</FloatItem>
        <FloatItem style={{ bottom: '15%', left: '8%', fontSize: '44px', animationDelay: '2s' }}>🎓</FloatItem>
        <FloatItem style={{ top: '45%', left: '3%', fontSize: '36px', animationDelay: '0.5s' }}>📝</FloatItem>
        <FloatItem style={{ bottom: '25%', right: '5%', fontSize: '42px', animationDelay: '1.5s' }}>📖</FloatItem>
        <FloatItem style={{ top: '12%', left: '25%', fontSize: '32px', animationDelay: '2.5s' }}>🧮</FloatItem>
        <FloatItem style={{ bottom: '10%', right: '20%', fontSize: '38px', animationDelay: '0.8s' }}>🏫</FloatItem>
        <FloatItem style={{ top: '60%', right: '3%', fontSize: '34px', animationDelay: '1.8s' }}>📐</FloatItem>
        <FloatItem style={{ top: '75%', left: '15%', fontSize: '30px', animationDelay: '3s' }}>🔔</FloatItem>
        <FloatItem style={{ top: '5%', right: '25%', fontSize: '36px', animationDelay: '2.2s' }}>👨‍🏫</FloatItem>
      </FloatingIcons>
      <LoginCard>
        <IconWrap>
          <HiOutlineCog6Tooth size={32} />
        </IconWrap>
        <Title>관리자 로그인</Title>
        <Subtitle>1등급 관리 시스템</Subtitle>

        <Form onSubmit={handleLogin}>
          <Label>아이디</Label>
          <Input
            type="text"
            placeholder=""
            value={loginId}
            onChange={(e) => setLoginId(e.target.value)}
            autoFocus
          />

          <Label>비밀번호</Label>
          <Input
            type="password"
            placeholder=""
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />

          {error && <ErrorText>{error}</ErrorText>}

          <LoginButton type="submit" disabled={loading}>
            {loading ? '로그인 중...' : '로그인'}
          </LoginButton>
        </Form>

      </LoginCard>
    </Container>
  );
};

export default AdminLoginPage;

const Container = styled.div`
  min-height: 100vh;
  width: 100%;
  background: linear-gradient(160deg, #F0F4FF 0%, #E8F0FE 50%, #F5F7FA 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
  position: relative;
  overflow: hidden;

  @keyframes float {
    0%, 100% { transform: translateY(0) rotate(0deg); }
    50% { transform: translateY(-20px) rotate(5deg); }
  }
`;

const FloatingIcons = styled.div`
  position: absolute;
  inset: 0;
  pointer-events: none;
`;

const FloatItem = styled.span`
  position: absolute;
  opacity: 0.15;
  animation: float 6s ease-in-out infinite;
  user-select: none;
`;

const LoginCard = styled.div`
  width: 100%;
  max-width: 400px;
  background: #FFFFFF;
  border-radius: 16px;
  padding: 40px 32px;
  box-shadow: 0 8px 32px rgba(74, 124, 254, 0.12), 0 2px 8px rgba(0, 0, 0, 0.06);
  position: relative;
  z-index: 1;
  text-align: center;
`;

const IconWrap = styled.div`
  width: 56px;
  height: 56px;
  border-radius: 14px;
  background: #4A7CFE;
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 16px;
`;

const Title = styled.h1`
  font-size: 22px;
  font-weight: 700;
  color: #1A1A2E;
`;

const Subtitle = styled.p`
  font-size: 14px;
  color: #9CA3AF;
  margin-top: 4px;
  margin-bottom: 28px;
`;

const Form = styled.form`
  text-align: left;
`;

const Label = styled.label`
  display: block;
  font-size: 13px;
  font-weight: 600;
  color: #374151;
  margin-bottom: 6px;
  margin-top: 16px;

  &:first-child {
    margin-top: 0;
  }
`;

const Input = styled.input`
  width: 100%;
  padding: 12px 14px;
  border: 1px solid #E5E7EB;
  border-radius: 8px;
  font-size: 15px;
  color: #1A1A2E;
  transition: border-color 0.2s;

  &::placeholder {
    color: #9CA3AF;
  }

  &:focus {
    border-color: #4A7CFE;
    outline: none;
  }
`;

const ErrorText = styled.p`
  color: #EF4444;
  font-size: 13px;
  margin-top: 12px;
`;

const LoginButton = styled.button`
  width: 100%;
  padding: 13px;
  border-radius: 8px;
  background: #4A7CFE;
  color: white;
  font-size: 15px;
  font-weight: 600;
  margin-top: 24px;
  transition: background 0.2s;

  &:hover {
    background: #3B6DE8;
  }

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
`;

